import React from 'react';
import styled from 'styled-components';

const Span = styled.span`
	color: red;
	font-weight: 600;
	border: 2px solid red;
	padding: 2rem;
	border-radius: 1rem;
`;

const WarningSpan = ({ children }) => {
	return <Span>{children}</Span>;
};

export default WarningSpan;
